export default interface ISelectItem {
    value: number,
    label: string
}